export enum StepNames {
	PERSONAL_DETAILS = 'PERSONAL DETAILS',
	PREFERENCES = 'PREFERENCES',
	RESUME = 'RESUME',
}
